/*=========================================================================================
  File Name: moduleRegionsActions.js
  Description: Regions Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axiosInstance from "../../libs/axios"

export default {

    addRegion({commit}, item) {
        return new Promise((resolve, reject) => {
            axiosInstance.post("/regions", item)
                .then((res) => {
                    const response = res.data.data
                    commit("ADD_ITEM", Object.assign(item, {id: response.data.id}));
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getRegions({dispatch, commit}, payload={}) {
        return new Promise((resolve, reject) => {
            axiosInstance.get("/regions", payload).then((response) => {
                commit("SET_REGIONS", response.data.data);
                resolve(response.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    updateRegion({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.put("/regions/" + payload.id, payload).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getRegionTranslations({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.get("/regions/" + payload).then((response) => {
                commit("SET_REGION_TRANSLATIONS", response.data);
                resolve(response.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getRegionInstitutions({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.get("/regions/" + payload.regionId + "/institutions").then((response) => {
                commit("SET_REGION_INSTITUTIONS", response.data.data);
                resolve(response.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    getRegionsDetailed({dispatch, commit}, payload={}) {
        let query = "&searchWord=" + (payload.searchWord ? payload.searchWord : "")
        return new Promise((resolve, reject) => {
            axiosInstance.get("/regions/detailed?orderByAlphabet=true" + query, payload).then((response) => {
                commit("SET_REGIONS_DETAILED", response.data.data);
                resolve(response.data.data)

            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    deleteRegion({dispatch, commit}, payload) {
        return new Promise((resolve, reject) => {
            axiosInstance.delete("/regions/" + payload).then((response) => {
                resolve(response.data.data.data)
            })
                .catch((error) => {
                    reject(error)
                })
        })
    },

}
